import { fallbackFontFamily } from './constants';
const getDefaultModalStyles = (tokens) => ({
    overlay: {
        background: 'rgba(0, 0, 0, 0.30)',
    },
    dialog: {
        borderRadius: tokens.BorderRadius04,
        borderWidth: tokens.BorderWidth01,
        boxShadow: '0px 4px 6px 0px rgba(26, 26, 26, 0.60)',
        paddingBottom: tokens.Spacing07,
        maxWidth: '520px',
        bgColor: tokens.Layer01,
        button: {
            _focus: {
                outline: 'none',
                boxShadow: 'none',
            },
            _focusVisible: {
                outlineColor: tokens.BorderFocus,
                outlineWidth: tokens.BorderWidth02,
                borderColor: tokens.BorderDark800,
                bgColor: tokens.Layer01,
                background: tokens.Layer01,
                boxShadow: 'none',
            },
        },
    },
    body: {
        paddingX: tokens.Spacing07,
    },
    header: {
        paddingTop: tokens.Spacing06,
        paddingBottom: tokens.Spacing04,
        paddingLeft: tokens.Spacing07,
        paddingRight: tokens.Spacing07,
        borderBottomWidth: tokens.BorderWidth01,
        borderColor: tokens.BorderLight200,
        color: tokens.TextMedium600,
        fontWeight: tokens.TextHeadingLight4FontWeight,
        fontSize: tokens.TextHeadingLight4FontSize,
        fontFamily: `${tokens.TextHeadingLight4FontFamily}, ${fallbackFontFamily}`,
        lineHeight: tokens.TextHeadingLight4LineHeight,
    },
});
const modalStyles = (tokens) => {
    const defaultStyle = getDefaultModalStyles(tokens);
    return {
        variants: {
            primary: defaultStyle,
            'primary-large': {
                ...defaultStyle,
                dialog: {
                    ...defaultStyle.dialog,
                    maxWidth: '800px',
                    minWidth: '660px',
                },
                body: {
                    ...defaultStyle.body,
                    py: 0,
                },
            },
        },
    };
};
export default modalStyles;
